export default {"src":"/_next/static/media/cloud.0e34651f.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};